import styles from './../styles.module.scss';
import skeleton from './styles.module.scss';

export default function SkeletonFavoriteCard() {
  const divsArray = Array.from({ length: 3 });
  return (
    <div>
      {divsArray.map((_, index) => (
        <div key={index} className={styles.container}>
          <div className={skeleton.container}>
            <div className={skeleton.container__infobox}>
              <div className={skeleton.banner} />
              <div className={skeleton.text} />
            </div>

            <div className={skeleton.container__betsbox}>
              <div className={skeleton.container__betsbox__smalltext} />
              <div className={skeleton.container__betsbox__smalltext} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
